import { render, staticRenderFns } from "./company-location-card-edit.vue?vue&type=template&id=7b28e54c&scoped=true&"
import script from "./company-location-card-edit.vue?vue&type=script&lang=js&"
export * from "./company-location-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./company-location-card-edit.vue?vue&type=style&index=0&id=7b28e54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28e54c",
  null
  
)

export default component.exports